export const socialZenMono24 = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0471 24H11.9514C7.18686 24 4.40038 23.5201 2.45941 21.6177C0.461319 19.5811 0 16.8131 0 12.0671V11.9329C0 7.18686 0.461319 4.40038 2.45941 2.38229C4.41895 0.479886 7.18686 0 11.9529 0H12.0486C16.7946 0 19.5811 0.479886 21.5392 2.38229C23.5373 4.42038 23.9986 7.18686 23.9986 11.9329V12.0671C23.9986 16.8146 23.5373 19.5996 21.5392 21.6177C19.5796 23.5201 16.8131 24 12.0471 24ZM20.3295 11.443C20.4538 11.4458 20.5523 11.5472 20.5523 11.6701V12.3313C20.5523 12.4542 20.4523 12.5556 20.3295 12.5584C17.3145 12.6413 15.5021 12.9098 14.2052 14.2066C12.907 15.5049 12.6399 17.3159 12.5585 20.3323C12.5556 20.4566 12.4542 20.5551 12.3314 20.5551H11.6673C11.5444 20.5551 11.443 20.4551 11.4402 20.3323C11.3573 17.3159 11.0903 15.5034 9.79344 14.2066C8.4966 12.9069 6.68418 12.6398 3.66775 12.5584C3.54349 12.5556 3.44495 12.4542 3.44495 12.3313V11.6701C3.44495 11.5472 3.54492 11.4458 3.66775 11.443C6.68275 11.3602 8.49517 11.0916 9.79201 9.79481C11.0903 8.49655 11.3573 6.68555 11.4388 3.66912C11.4416 3.54487 11.543 3.44632 11.6658 3.44632H12.33C12.4528 3.44632 12.5542 3.5463 12.5571 3.66912C12.6385 6.68698 12.9056 8.49797 14.2038 9.79481C15.5006 11.0945 17.3131 11.3616 20.3295 11.443Z"
      />
    </svg>
  );
};
